import script from "./AppModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppModal.vue?vue&type=script&setup=true&lang=ts"

import "./AppModal.vue?vue&type=style&index=0&id=5fc5675c&lang=css"

const __exports__ = script;

export default __exports__